import React from 'react';
import { Benefits } from '../../../types/product';

interface BenefitsSectionProps {
  value: Benefits;
  onChange: (value: Benefits) => void;
}

// 旧 styled 定義をそのまま Tailwind クラス文字列にした定数（sections 共通の見た目）。
const SECTION = 'bg-white border border-[#e0e0e0] rounded-lg p-6 mb-6';
const SECTION_TITLE = 'm-0 mb-2 text-[18px] font-semibold text-[#333]';
const SECTION_DESCRIPTION = 'm-0 mb-6 text-[14px] text-[#666]';
const FIELD_GROUP = 'mb-5 last:mb-0';
const LABEL = 'block mb-2 text-[14px] font-semibold text-[#333]';
const TEXTAREA =
  'w-full px-3 py-2.5 border border-[#ddd] rounded-md text-[14px] [font-family:inherit] resize-y transition-[border-color] duration-200 ease-[ease] focus:outline-none focus:border-[#4CAF50]';
const HELP_TEXT = 'm-0 mt-1.5 text-[12px] text-[#666]';

export const BenefitsSection: React.FC<BenefitsSectionProps> = ({
  value,
  onChange
}) => {
  const handleChange = (field: keyof Benefits, fieldValue: string) => {
    onChange({ ...value, [field]: fieldValue });
  };

  return (
    <div className={SECTION}>
      <h3 className={SECTION_TITLE}>ベネフィット</h3>
      <p className={SECTION_DESCRIPTION}>
        顧客が得られる価値を3つの層で入力してください
      </p>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>機能的ベネフィット</label>
        <textarea
          className={TEXTAREA}
          value={value.functional || ''}
          onChange={(e) => handleChange('functional', e.target.value)}
          placeholder="例: 定期配送で買い運びゼロ"
          rows={3}
        />
        <p className={HELP_TEXT}>製品・サービスが提供する直接的な機能的価値</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>情緒的ベネフィット</label>
        <textarea
          className={TEXTAREA}
          value={value.emotional || ''}
          onChange={(e) => handleChange('emotional', e.target.value)}
          placeholder="例: 清潔な暮らしへの安心感"
          rows={3}
        />
        <p className={HELP_TEXT}>顧客が感じる心理的・感情的価値</p>
      </div>

      <div className={FIELD_GROUP}>
        <label className={LABEL}>自己実現ベネフィット</label>
        <textarea
          className={TEXTAREA}
          value={value.self_realization || ''}
          onChange={(e) => handleChange('self_realization', e.target.value)}
          placeholder="例: エコで持続可能な生活の実現"
          rows={3}
        />
        <p className={HELP_TEXT}>顧客の自己実現や価値観の表現に関する価値</p>
      </div>
    </div>
  );
};
